import storage from './storage';

class AuthManager {
  login(username, password, rememberMe = false) {
    const users = storage.getUsers();
    const passwordHash = storage.hashPassword(password);
    
    const user = users.find(
      u => u.username === username && u.passwordHash === passwordHash
    );

    if (user) {
      const session = {
        userId: user.id,
        username: user.username,
        role: user.role,
        loginTime: new Date().toISOString(),
        rememberMe
      };
      
      storage.setCurrentUser(user);
      storage.setSession(session);
      return { success: true, user };
    }

    return { success: false, error: 'Invalid username or password' };
  }

  register(username, password, role = 'user') {
    const users = storage.getUsers();
    
    // Check if username already exists
    if (users.find(u => u.username === username)) {
      return { success: false, error: 'Username already exists' };
    }

    const newUser = {
      id: `user-${Date.now()}`,
      username,
      passwordHash: storage.hashPassword(password),
      role,
      createdAt: new Date().toISOString()
    };

    users.push(newUser);
    storage.setUsers(users);

    return { success: true, user: newUser };
  }

  logout() {
    storage.removeItem('retailflow_current_user');
    storage.removeItem('retailflow_session');
  }

  getCurrentUser() {
    return storage.getCurrentUser();
  }

  getSession() {
    return storage.getSession();
  }

  isAuthenticated() {
    const session = this.getSession();
    return session !== null;
  }

  hasPermission(requiredRole) {
    const user = this.getCurrentUser();
    if (!user) return false;

    const roleHierarchy = { owner: 3, manager: 2, staff: 1 };
    const userLevel = roleHierarchy[user.role] || 0;
    const requiredLevel = roleHierarchy[requiredRole] || 0;

    return userLevel >= requiredLevel;
  }
}

export default new AuthManager();